import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { testableRoutes, routes } from 'utils/constants';
import { useTestable } from 'utils/testable/testable';

/**
 * Routing validation
 * !important useRouteValidation is called inside the Page wrapper
 * Here we will listen on any changes to routing paths and
 * perform redirects if the route shouldn't be accessible by the user
 */
export const useRouteValidation = () => {
  const router = useRouter();
  const { isReady, replace, query } = router;
  const { testableFeaturesEnabled } = useTestable();

  useEffect(() => {
    if (!isReady) return;

    // Get the pathname from the router
    let { pathname } = router;

    // Next.js router incorrectly reports the pathname as '/' on remote (not local) builds,
    // probably because we are using output: export in next.config.js
    // https://nextjs.org/docs/pages/guides/static-exports
    // If setLocale is called, it will update the query param but not change the location,
    // and the router will still report the pathname as '/'.
    // so as a workaround we use the actual window location pathname
    if (pathname === '/' && typeof window !== 'undefined') {
      pathname = window.location.pathname;
    }

    const isTestableRoute = Object.keys(testableRoutes).includes(pathname);
    const isAppRoute = Object.keys(routes).includes(pathname);

    let newPath;
    newPath = isAppRoute ? pathname : routes['/error'];

    if (isTestableRoute) {
      newPath = testableFeaturesEnabled() ? pathname : routes['/error'];
    }

    replace({
      pathname: newPath,
      query: { ...query },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};
